import React from "react";
import Footer from './Footer';
import FloatingButtons from '../../pages/web/FloatingButtons';
import Header from "./Header";
import { useSelector } from "react-redux";
import Breadcrumbs from "../ui/Breadcrumbs";
function Layout({ children }) {
    const setting = useSelector((state) => state?.globalState?.siteSetting?.site_settings);
  

    return (
        <div className="min-h-screen bg-gray-50">
            {/* <Header/> */}
                  <Breadcrumbs/>

            <div>
                {children}
            </div>

                <Footer/>
            <FloatingButtons whatsapp={setting.site_whatsapp}/>
        </div>
    );
}

export default Layout;